var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 378,
    viewBox: "0 0 61 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-281.4 62.6176C-250.108 29.8413 -209.768 8.14435 -161.597 2.49717C-107.47 -3.83849 -58.4801 9.43923 -15.4494 42.9467C22.7684 72.7156 48.7516 115.49 57.6335 163.252C66.5146 211.014 57.6845 260.488 32.7964 302.401C23.4443 318.041 12.0544 332.363 -1.0728 344.991C-9.01532 352.693 -16.2205 361.357 -24.9568 368.01C-45.4753 383.619 -72.4325 380.447 -89.0895 361.475C-104.994 343.337 -103.739 315.611 -85.998 297.156C-76.2486 287.008 -65.6343 277.569 -56.481 266.968C-32.4387 239.101 -20.4826 207.062 -33.7695 171.36C-49.9622 127.661 -80.8529 98.8288 -128.688 93.1533C-159.981 89.4457 -186.477 102.203 -209.185 123.264C-217.566 131.04 -225.431 139.395 -233.535 147.481C-252.95 166.93 -281.91 167.926 -300.48 149.884C-319.741 131.166 -319.877 102.273 -300.665 81.9474C-295.131 76.1178 -289.296 70.5271 -281.4 62.6176Z",
    fill: "url(#paint0_linear_2097_812)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2097_812",
    x1: -260.895,
    y1: -21.8306,
    x2: -260.895,
    y2: 508.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE9D3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE9D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsCurve);
export default __webpack_public_path__ + "static/media/about-us-curve.0d1563f01c0a7e198abd10aa8c31ac90.svg";
export { ForwardRef as ReactComponent };